module.exports = __webpack_public_path__ + "static/7-37019a1a8b8ee615083c67a327523668.jpeg";